(() => {
  const SECTION_SELECTOR = '.section--key-ingredients';
  const TRIGGER_SELECTOR = '[data-key-ingredients-modal-trigger]';
  const CLOSE_SELECTOR = '[data-key-ingredients-modal-close]';
  const MODAL_SELECTOR = 'dialog.key-ingredients__modal';
  const SCROLL_DISABLED_CLASS = 'u-scroll-disabled';

  const openModal = (sectionEl, trigger) => {
    const modalId = trigger.getAttribute('data-key-ingredients-modal-trigger');
    if (!modalId) return;

    const dialog = sectionEl.querySelector(`#${modalId}`);
    if (!dialog || typeof dialog.showModal !== 'function') return;

    dialog.showModal();
    document.body.classList.add(SCROLL_DISABLED_CLASS);
  };

  const closeModal = (dialog) => {
    if (!dialog || typeof dialog.close !== 'function') return;
    dialog.close();
    document.body.classList.remove(SCROLL_DISABLED_CLASS);
  };

  const onSectionClick = (sectionEl, event) => {
    const trigger = event.target.closest(TRIGGER_SELECTOR);
    if (trigger) {
      openModal(sectionEl, trigger);
      return;
    }

    const closeButton = event.target.closest(CLOSE_SELECTOR);
    if (closeButton) {
      closeModal(closeButton.closest('dialog'));
      return;
    }

    const dialog = event.target.closest(MODAL_SELECTOR);
    if (!dialog) return;

    const rect = dialog.getBoundingClientRect();
    const clickedBackdrop =
      event.clientX < rect.left ||
      event.clientX > rect.right ||
      event.clientY < rect.top ||
      event.clientY > rect.bottom;

    if (clickedBackdrop) {
      closeModal(dialog);
    }
  };

  const bindSection = (sectionEl) => {
    if (sectionEl.dataset.keyIngredientsBound === 'true') return;
    sectionEl.dataset.keyIngredientsBound = 'true';

    sectionEl.addEventListener('click', (event) => onSectionClick(sectionEl, event));
    sectionEl.addEventListener('close', (event) => {
      if (event.target.matches(MODAL_SELECTOR)) {
        document.body.classList.remove(SCROLL_DISABLED_CLASS);
      }
    }, true);
  };

  const init = () => {
    document.querySelectorAll(SECTION_SELECTOR).forEach(bindSection);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
